var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ActionButton',{attrs:{"click-action":_vm.deleteItem,"title":_vm.$t('general.delete'),"disabled":_vm.disabled}},[_c('b-icon-trash')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }